<template>
<div id="main">
    <router-view></router-view>
</div>
</template>

<script>
export default {
    name: "main",
    data() {
        return {
            valueQuestion: 0
        }
    },
    methods: {}
};
</script>

<style>
.container {
    max-width: 1175px;
    margin: 0 auto;
    padding: 0 10px;
}

* {
    box-sizing: border-box;
}

html,
body {
    padding: 0;
    margin: 0;
}

ul,
li,
a {
    text-decoration: none;
    padding: 0;
    margin: 0;
    list-style: none;
    display: inline-block;
}

.body__bg {
    position: fixed;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
    z-index: 400;
    display: none;
}

.header {
    z-index: 999;
}

@font-face {
    font-family: "Roboto-Light";
    src: url(/fonts/Roboto-Light.ttf);
}

@font-face {
    font-family: "Roboto-Regular";
    src: url(/fonts/Roboto-Regular.ttf);
}

@font-face {
    font-family: "Roboto-Bold";
    src: url(/fonts/Roboto-Bold.ttf);
}

button {
    cursor: pointer;
    border: 0;
    outline: none;
    background-color: inherit;
}

h1 {
    font-size: 73px;
    line-height: 85px;
    color: #fff599;
    font-family: "Roboto-Bold";
    margin: 0 auto;
    display: inline-block;
}

h2 {
    font-size: 32px;
    line-height: 38px;
    font-family: "Roboto-Light";
    margin: 0;
}

h3 {
    font-size: 24px;
    line-height: 18px;
    font-family: "Roboto-Regular";
    margin: 0;
}

button {
    font-family: "Roboto-Bold";
    color: #fff;
}

.footer {
    position: absolute;
    bottom: 0;
}

.question {
    min-height: 700px;
}

.help__block {
    position: fixed;
    bottom: 10%;
    left: 0;
    width: 100%;
}

.question__help {
    color: #fff599;
    font-size: 31.3803px;
    font-family: "Roboto-Light";
    background: rgba(26, 23, 23, 0.5);
    border: 0.45px solid #FFF599;
    bottom: 4%;
    right: 3%;
    border-radius: 15px;
    padding: 6px 14px 6px 56px;
    position: absolute;
}

.question__help:before {
    content: '';
    position: absolute;
    width: 36px;
    height: 36px;
    background-image: url(/img/icon-question.svg);
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
}

.question__help {
    transform: translate3d(0, 0, 0) scale(1);
}

.question__help::before {
    position: absolute;
    content: "";
}

.question__help {
    animation: phone-outer 3000ms infinite;
}

@keyframes phone-outer {
    0% {
        transform: translate3d(0, 0, 0) scale(1);
        box-shadow:
            0 0 0 0em rgba(#3498db, 0),
            0em 0.05em 0.1em rgba(#000000, 0.2);
    }

    33.3333% {
        transform: translate3d(0, 0, 0) scale(1.1);
        box-shadow:
            0 0 0 0em rgba(#3498db, 0.1),
            0em 0.05em 0.1em rgba(#000000, 0.5);
    }

    66.6666% {
        transform: translate3d(0, 0, 0) scale(1);
        box-shadow:
            0 0 0 0.5em rgba(#3498db, 0),
            0em 0.05em 0.1em rgba(#000000, 0.2);
    }

    100% {
        transform: translate3d(0, 0, 0) scale(1);
        box-shadow:
            0 0 0 0em rgba(#3498db, 0),
            0em 0.05em 0.1em rgba(#000000, 0.2);
    }
}

.btn {
    font-family: "Roboto-Regular";
    color: #000000;
    background-color: #fff;
    border-radius: 10px;
    text-transform: uppercase;
    font-size: 18px;
    line-height: 16px;
    padding: 12px 10px;
    transition: all .4s;
}

.btn-prev {
    color: #fff599;
    font-size: 24px;
    font-family: "Roboto-Regular";
    padding: 9px 24px 9px 50px;
    border: 1px solid #fff599;
    border-radius: 25px;
    text-transform: uppercase;
    position: absolute;
    top: 59%;
    transform: translateY(-50%);
    left: 0;
}

.btn-next {
    color: #FFFFFF;
    font-size: 24px;
    line-height: 28px;
    font-family: "Roboto-Bold";
    padding: 9px 54px;
    background: linear-gradient(180deg, #04C44C 0%, #20C05C 100%);
    border-radius: 20.9362px;
    box-sizing: border-box;
    text-transform: uppercase;
}

.btn-prev span {
    position: relative;
    width: 100%;
    display: block;
}

.btn-prev span:before,
.btn-prev span:after {
    content: '';
    background-image: url(/img/icon-arrow-prev.svg);
    height: 20px;
    width: 12px;
    position: absolute;
    background-repeat: no-repeat;
    left: -20px;
    top: 50%;
    transform: translateY(-50%);
}

.btn-prev span:after {
    left: -30px;
}

.main__question-btn {
    position: absolute;
    right: -50px;
    top: -10px;
}

.main__question-btn:hover,
.main__question-btn:focus {
    color: #fff;
    background: transparent;
    outline: none;
}

.main__question-btn:before,
.main__question-btn:after {
    content: attr(data-tip);
    font-size: 16px;
    font-family: "Roboto-Regular";
    background: #FFFFFF;
    border-radius: 15px;
    line-height: 18px;
    padding: 25px 27px;
    width: 360px;
    color: black;
    text-align: center;
    top: 50px;
    right: -140px;
    z-index: 100;
    border-radius: 20% 50%/50% 20%;
    box-shadow: 0 0 10px -2px rgba(0, 0, 0, 0.5);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease 0s;
}

.main__question-btn:after {
    content: '';
    height: 10px;
    width: 10px;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
}

.main__question-btn:hover:before,
.main__question-btn:hover:after {
    opacity: 1;
    visibility: visible;
}

.main__question-btn:before,
.main__question-btn:after {
    transform: translateX(-50%) rotateY(90deg);
    position: absolute;
    top: calc(130% - 4px);
    left: 50%;
}

.main__question-btn:after {
    transform: translateX(-50%) rotate(45deg) rotateY(90deg);
    top: calc(130% - 4px);
}

.main__question-btn:hover:before {
    transform: translateX(-50%) rotateY(0);
    top: 130%;
}

.main__question-btn:hover:after {
    transform: translateX(-50%) rotate(45deg) rotateY(0);
}

.main__question-main {
    max-width: 790px;
    margin: 0 auto;
}

@media (max-width: 1500px) {
    .main__question-btn:before {
        left: -200px;
        top: 40px;
    }

    .main__question-btn:hover:before {
        top: 185%;
    }

    .main__question-btn:after {
        display: none;
    }
}

@media (max-width: 1250px) {
    .question__help {
        padding: 3px 13px 3px 51px;
        font-size: 29px;
    }

    .question__help:before {
        width: 33px;
        height: 33px;
        background-size: cover;
    }

    .btn-prev {
        font-size: 21px;
        padding: 9px 15px 9px 35px;
    }

    .btn-prev span:before,
    .btn-prev span:after {
        width: 8px;
        height: 16px;
        background-size: cover;
    }

    .btn-prev span:before {
        left: -17px;
    }

    .btn-prev span:after {
        left: -25px;
    }
}

@media (max-width: 680px) {
    .main__question-btn:before {
        left: -160px;
    }

    .main__question-btn:hover:before {
        top: 76%;
    }

    .main__question-btn {
        right: -0px !important;
    }
}

@media (max-width: 500px) {
    .question__help {
        padding: 4px 8px 4px 32px;
        font-size: 14px;
        border-radius: 7px;
    }

    .question__help:before {
        width: 18px;
        height: 18px;
    }

    .btn-prev {
        padding: 9px 13px 9px 31px;
        font-size: 14.9647px;
        border-radius: 15.5882px;
    }

    .btn-prev span:before,
    .btn-prev span:after {
        width: 6px;
        height: 10px;
    }

    .btn-prev span:before {
        left: -12px;
    }

    .btn-prev span:after {
        left: -20px;
    }

    .main__question-btn:before {
        left: -105px;
        font-size: 13px;
        width: 250px;
        padding: 20px;
    }

    .main__question-btn:hover:before {
        top: 76%;
    }

    .main__question-2 .main__question-btn {
        right: 0;
    }
    .btn-next {
        width: 174px;
        height: 44px;
        padding: 0;
        font-size: 20px;
    }
}
</style>
